import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  gap: 10,
  paddingBottom: 20,
}));

export const DirectionButton = styled("button")(({ theme, $active }) => ({
  ...theme.mixins.flexAlignCenter,
  gap: 8,
  border: "none",
  backgroundColor: $active ? theme.palette.fly.brand : theme.palette.fly.inputBg,
  color: $active ? theme.palette.white : theme.palette.fly.brand,
  ...theme.paddings(10, 14),
  borderRadius: 7,
  cursor: "pointer",
  transition: "all .2s ease",

  "&:hover": {
    backgroundColor: $active ? theme.palette.fly.brandHover : "#e8eaec",
  },
}));

export const DirectionButtonIcon = styled("span")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  fontSize: 14,
  lineHeight: 1,
}));

export const DirectionButtonText = styled("span")(({ theme }) => ({
  fontSize: 14,
  lineHeight: "17px",
  fontWeight: 500,
  letterSpacing: "0.06em",
}));
